/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
   fetchformateursalarie({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/getformateursalarie")
        .then((response) => {
          commit('SET_SALARIE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
   addItem({ commit }, item) {
     return new Promise((resolve, reject) => {
       axios.post("https://trainingcenterback.codily.net/api/addformateur", item)
         .then((response) => {
           commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
           resolve(response)
         })
         .catch((error) => { reject(error) })
     })
   },
  fetchUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/getformateur")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/getformateur_id/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormations({ commit},userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classes_formateur_id/${userId}`)
        .then((response) => {
          commit('SET_USERS', response.data)
          console.log('userId',userId)
          console.log('response.data',response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`https://trainingcenterback.codily.net/api/destroyformateur/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateRecord({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/updateformateur/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          console.log("user",user)
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateavatarRecord({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/updateformateuravatar/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          console.log("user",user)
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
}
